// CreateAccidentDialog/index.js
import { connect } from 'react-redux';
import CreateAccidentDialog from '../../components/CreateAccidentDialog';

import {
  openCreateAccidentDialogDispatch,
  handleAccidentInputChangeDispatch,
  fetchAllPersonnelsDispatch,
  submitAccidentDispatch,
  removeAccidentAttachment,
  openCreatePersonnelDialogDispatch
} from '../../actions';
import { submitMode } from '../../constants';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.accident.newAccident.showCreateAccidentDialog,
    accident: state.accident.newAccident.item,
    isSaving: state.accident.newAccident.isSaving,
    personnels: state.personnels.allPersonnels.items,
    userId: state.users.user.item.id,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    isLoadingPersonnel: state.personnels.allPersonnels.isLoading,
    allAttachments: state.accident.newAccident.item.attachmentFiles
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openCreateAccidentDialog: (open) => {
      dispatch(openCreateAccidentDialogDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleAccidentInputChangeDispatch(value, inputFieldName));
    },
    submitAccident: (accident) => {
      const mode = submitMode.CREATE;
      dispatch(submitAccidentDispatch(accident, mode));
    },
    fetchAllPersonnels: (userId) => {
      dispatch(fetchAllPersonnelsDispatch(userId));
    },
    onUpdateAttachment: (value, inputFieldName) => {
      dispatch(handleAccidentInputChangeDispatch(value, inputFieldName));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeAccidentAttachment(attachment));
    },
    openCreatePersonnelDialog: (open) => {
      dispatch(openCreatePersonnelDialogDispatch(open, true));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAccidentDialog);
